import * as React from "react";
import styled from "styled-components";

interface IAddressInfosProps {
  // title?: string;
  address: string;
  address2?: string;
  postalCode: string;
  city: string;
  country?: string;
  stateProvince?: string;
  style?: React.CSSProperties;
  addressTypes?: string[];
}

const StyledDiv = styled.div`
  font-weight: bold;
`;

export const AddressInfos: React.FunctionComponent<IAddressInfosProps> = (
  props
) => {
  return (
    <div style={props.style}>
      {props.address}
      {props.address2 && (
        <>
          <br />
          {props.address2}
        </>
      )}
      <br />
      {props.postalCode} {props.city} <br />
      {props.stateProvince && (
        <>
          {props.stateProvince}
          <br />
        </>
      )}
      {props.country}
      <br />
      <br />
      <StyledDiv>
        {props.addressTypes?.map((e) => (
          <>
            {e}
            <br />
          </>
        ))}
      </StyledDiv>
    </div>
  );
};
